import _ from 'lodash';
import Rx from 'ub_wrapped/rx';

import ubBanzai from 'ub/control/banzai-features';
import googleFontsApi from 'ub/fonts/font-service/google/api';
import googleFonts from 'ub/fonts/font-service/google/fonts';
import FontServiceManager from 'ub/fonts/font-service/manager';
import FontSortAndFilter from 'ub/fonts/font-service/sort-filter';

import initialState from './initial-state';

const FONT_START_INDEX = 0;
const ADDED_FONT_LIMIT = ubBanzai.getFeatureValue('maximumNumberOfFonts');
const fontPagnationLimit = ubBanzai.getFeatureValue('fontPaginationLimit');
const updateStateSubject = new Rx.Subject();

const cancelRemoveFont = (currentState) => {
  return {
    ...currentState,
    showRemoveFontConfirmation: false,
    fontFamilyToRemove: ''
  };
};

const closeMaxFontOverlay = (currentState) => {
  return {
    ...currentState,
    showMaxFontsOverlay: false
  };
};

const renderInitialState = () => {
  FontSortAndFilter.resetFontList();

  return initialState;
};

const loadPreviewGoogleFonts = (currentState, fontData) => {
  const fontMap = googleFonts.fontMap;

  // For the font grid modal, we only want to load the 'regular' font,
  // or the first weight in the 'variant' set for performance purposes
  const fontSet = _.map(fontData, (fontFamily) => {
    const fontData = fontMap[fontFamily];
    const variants = fontData.variants;

    let fontWeight = 'regular';

    if (!_.contains(variants, fontWeight)) {
      fontWeight = _.first(variants);
    }

    return `${fontFamily}:${fontWeight}`;
  });

  googleFontsApi.loadGoogleFonts(fontSet);

  return currentState;
};

const closeModal = (currentState) => {
  return {
    ...currentState,
    isOpen: false
  };
};

const addFont = (currentState, fontData) => {
  if (FontServiceManager.addedWebFonts.length >= ADDED_FONT_LIMIT) {
    return {
      ...currentState,
      showMaxFontsOverlay: true,
    };
  }

  FontServiceManager.addFont(fontData);

  const newFontList = {...currentState.fontList};

  newFontList[fontData.family] = {
    ...newFontList[fontData.family],
    isAdded: true
  };

  const newState = {
    ...currentState,
    fontList: newFontList
  };

  return newState;
};

const confirmFontRemoval = (currentState, fontData) => {
  FontServiceManager.removeFont(fontData);

  const newFontList = {...currentState.fontList};

  newFontList[fontData.family] = {
    ...newFontList[fontData.family],
    isAdded: false
  };

  return {
    ...currentState,
    fontList: newFontList,
    showRemoveFontConfirmation: false,
    fontFamilyToRemove: ''
  };
};

const removeFont = (currentState, fontData) => {
  const fontFamily = fontData.family;

  let newState = {...currentState};

  const fontIsInUse = FontServiceManager.isFontInUse(fontFamily);

  if (fontIsInUse) {
    newState.showRemoveFontConfirmation = true;
    newState.fontFamilyToRemove = fontFamily;
  } else {
    newState = confirmFontRemoval(currentState, fontData);
  }

  return newState;
};

const fetchFonts = (currentState) => {
  const start = _.size(currentState.fontList);
  const end = start + fontPagnationLimit;

  const newFonts = FontSortAndFilter.getFontsAtRange(start, end);

  return {
    ...currentState,
    fontList: {
      ...currentState.fontList,
      ...newFonts
    }
  };
};

const showFonts = (currentState, fontFamilyList) => {
  const currentFonts = _.keys(currentState.fontList);

  const updatedFontArray = _(fontFamilyList)
    .intersection(currentFonts)
    .map((fontFamily) => {
      const result = {};

      result[fontFamily] = {loaded: true};

      return result;
    })
    .value();

  const newFontList = _.merge({...currentState.fontList}, ...updatedFontArray);

  return {
    ...currentState,
    fontList: newFontList
  };
};

const filterFontList = (currentState, searchText) => {
  FontSortAndFilter.filterAndUpdateFontList(searchText);

  const filteredFonts = FontSortAndFilter.getFontsAtRange(
    FONT_START_INDEX,
    fontPagnationLimit
  );

  return {
    ...currentState,
    fontList: filteredFonts
  };
};

export default {
  updateStateSubject,
  renderInitialState,
  loadPreviewGoogleFonts,
  addFont,
  removeFont,
  confirmFontRemoval,
  fetchFonts,
  showFonts,
  closeModal,
  cancelRemoveFont,
  filterFontList,
  closeMaxFontOverlay,
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-actions.js